import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import List from '@/components/List'
import EndList from '@/components/EndList'
import ApprovalIndex from '@/components/ApprovalIndex'
import Temp from '@/components/Temp'
import Test from '@/components/Test'
import Project from '@/components/Project'
import Viewpdf from '@/components/Viewpdf'
import Report from '@/components/Report'
import Help from '@/components/Help'
import Closure from '@/components/Closure'
import Practice from '@/components/Practice'
import TaskSet from '@/components/TaskSet'
import TaskList from '@/components/TaskList'
import TaskDetail from '@/components/TaskDetail'
import UnitCostMaintanance from '@/components/UnitCostMaintanance'
import UnitCostMaintananceEdit from '@/components/UnitCostMaintananceEdit'
import CategoryMaintanance from '@/components/CategoryMaintanance'
import CRMange from '@/components/CR'
import CRDataBase from '@/components/CRDataBase'
import CRDataBaseDetail from '@/components/CRDataBaseDetail'
import CRMangeAdd from '@/components/CRAdd'
import CRAddSummary from '@/components/CRAddSummary'
import ProjectDatabase from '@/components/ProjectDatabase'
import CRSupplement from '@/components/CRSupplement'
import CRSupplementList from '@/components/CRSupplementList'
import SmartCRData from '@/components/SmartCRData'
import TaskTemplate from '@/components/TaskTemplate'
import TaskTemplateSet from '@/components/TaskTemplateSet'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/List',
      name: 'List',
      component: List
    },
    {
      path: '/EndList',
      name: 'EndList',
      component: EndList,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/ApprovalIndex',
      name: 'ApprovalIndex',
      component: ApprovalIndex,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/Temp',
      name: 'Temp',
      component: Temp
    },
    {
      path: '/Test/:projectID',
      name: 'Test',
      component: Test
    },
    {
      path: '/Project',
      name: 'Project',
      component: Project
    },
    {
      path: '/Help',
      name: 'Help',
      component: Help
    },
    {
      path: '/Viewpdf',
      name: 'Viewpdf',
      component: Viewpdf
    },
    {
      path: '/Report',
      name: 'Report',
      component: Report
    },
    {
      path: '/Closure',
      name: 'Closure',
      component: Closure
    },
    {
      path: '/Practice',
      name: 'Practice',
      component: Practice
    },
    {
      path: '/TaskSet',
      name: 'TaskSet',
      component: TaskSet
    },
    {
      path: '/TaskList',
      name: 'TaskList',
      component: TaskList
    },
    {
      path: '/TaskDetail/:ID',
      name: 'TaskDetail',
      component: TaskDetail
    },
    {
      path: '/UnitCostMaintanance',
      name: 'UnitCostMaintanance',
      component: UnitCostMaintanance
    },
    {
      path: '/ProjectDatabase',
      name: 'ProjectDatabase',
      component: ProjectDatabase
    },
    {
      path: '/UnitCostMaintananceEdit',
      name: 'UnitCostMaintananceEdit',
      component: UnitCostMaintananceEdit
    },
    {
      path: '/CategoryMaintanance',
      name: 'CategoryMaintanance',
      component: CategoryMaintanance
    },
    {
      path: '/CRMange',
      name: 'CRMange',
      component: CRMange
    },
    {
      path: '/CRDataBase',
      name: 'CRDataBase',
      component: CRDataBase
    },
    {
      path: '/CRDataBaseDetail/:id',
      name: 'CRDataBaseDetail',
      component: CRDataBaseDetail
    },
    {
      path: '/CRMangeAdd',
      name: 'CRMangeAdd',
      component: CRMangeAdd
    },
    {
      path: '/CRAddSummary',
      name: 'CRAddSummary',
      component: CRAddSummary
    },
    {
      path: '/CRSupplement',
      name: 'CRSupplement',
      component: CRSupplement
    },
    {
      path: '/CRSupplementList',
      name: 'CRSupplementList',
      component: CRSupplementList
    },
    {
      path: '/SmartCRData',
      name: 'SmartCRData',
      component: SmartCRData
    },
    {
      path: '/TaskTemplate',
      name: 'TaskTemplate',
      component: TaskTemplate
    },
    {
      path: '/TaskTemplateSet',
      name: 'TaskTemplateSet',
      component: TaskTemplateSet
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js